import { getGameConfig } from '../../../gameConfig';
import { IQualifiedGuildRecruitmentTag } from '../../../gameConfig/sharedTypes';

const gameConfig = getGameConfig();

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};

const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center'
};

export const formatGroupLabel = (data: any) => (
  <div style={groupStyles as any}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles as any}>{data.options.length}</span>
  </div>
);

/**
 * Find a qualified tag that matches any of the given tags
 */
export const findQualifiedTagFromTags = (tags: { id: number }[]): IQualifiedGuildRecruitmentTag | undefined =>
  gameConfig.QualifiedGuildRecruitmentTags.find((qt) => tags.some((t) => qt.tagId === t.id));

/**
 * Get a qualified tag by its tag ID
 */
export const getQualifiedTagById = (tagId: number): IQualifiedGuildRecruitmentTag | undefined =>
  gameConfig.QualifiedGuildRecruitmentTags.find((qt) => qt.tagId === tagId);

/**
 * Find a qualified tag for a guild by its guild ID
 */
export const findQualifiedTagForGuild = (guildId: number): IQualifiedGuildRecruitmentTag | undefined =>
  gameConfig.QualifiedGuildRecruitmentTags.find((qt) => qt.approvedGuildIds.includes(guildId));

